// extracted by mini-css-extract-plugin
export default {"button":"EyeDropperButton_button__V8Qwi","active":"EyeDropperButton_active__-UaD8"};